import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Icon, ICONS, PLATFORM_THEME_COLORS, Popover } from '@thinknet-gmbh/platform-common-ui';
import { PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { JOBS_MODALS, JOBS_PAGES } from 'src/pages/jobs/jobs.constants';
import { IJob } from 'src/pages/jobs/jobs.interfaces';
import { useUserCanManageDocument } from 'src/hooks/user-can-manage-document.hook';

const JobsListTableRowPopover = ({
  record,
  getCurrentJob,
}: {
  record: IJob;
  getCurrentJob: (value: IJob, modal: string) => void;
}) => {
  const { t } = useTranslation(['employee', 'jobs']);
  const navigate = useNavigate();
  const { canDelete, canEdit } = useUserCanManageDocument({
    createdBy: record.job.createdBy,
    platformPermission: PLATFORM_PERMISSIONS.jobManagement,
  });

  return (
    <Popover
      elements={[
        {
          label: t('employee:labels.viewDetails'),
          icon: ICONS.foodMenu,
          key: ICONS.foodMenu,
          handler: () =>
            navigate(`${ROUTES.jobs}/${JOBS_PAGES.jobDetailsPage}?id=${record.job._id}`, {
              state: { companyId: record.companyId, departmentId: record.departmentId },
            }),
        },
        // TODO: Add missed modal field - "jobLocation"
        // {
        //   label: t('jobs:labels.setJobToEmployee'),
        //   icon: ICONS.userPlus,
        //   key: ICONS.userPlus,
        //   handler: () => getCurrentJob(record, JOBS_MODALS.setJobToEmployee),
        // },
        {
          label: t('jobs:labels.startVacancyProcess'),
          icon: ICONS.playCircle,
          key: ICONS.playCircle,
          ...(!canEdit && { color: PLATFORM_THEME_COLORS.grayVariations.murky }),
          handler: () => {
            if (canEdit) {
              getCurrentJob(record, JOBS_MODALS.createVacancy);
            }
          },
        },
        {
          label: t('jobs:deleteJob.title'),
          icon: ICONS.trash,
          key: ICONS.trash,
          color: canDelete
            ? PLATFORM_THEME_COLORS.tone.red
            : PLATFORM_THEME_COLORS.grayVariations.murky,
          handler: () => {
            if (canDelete) {
              getCurrentJob(record, JOBS_MODALS.deleteJob);
            }
          },
        },
      ]}
    >
      <Icon
        icon={ICONS.dotsVerticalRounded}
        color={PLATFORM_THEME_COLORS.primary.grey}
        rightMargin={false}
        size={22}
      />
    </Popover>
  );
};

export default JobsListTableRowPopover;
